// extracted by mini-css-extract-plugin
export default {"addIcon":"CustomTable_addIcon__TH0J1","tableCell":"CustomTable_tableCell__6nZ++"};